import React from 'react'; 
import RemoveCircleIcon from '@material-ui/icons/Remove';
import CheckIcon from "@material-ui/icons/Check"; 
import ToggleButton from '@material-ui/lab/ToggleButton';
import { Grid, Tooltip, withStyles } from "@material-ui/core";
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import Entity from "../Entity";
import styles from "../styles";
import moment from "moment";

function setUpUtter(utteranceData) {
  let utter = [];
  let idx = 0;
  utteranceData.entities.forEach((item, index) => {
    utter.push(
      React.createElement(
        "span",
        { className: "unrecognized", key: index },
        utteranceData.UserInput.slice(idx, item.start)
      )
    );
    let part = utteranceData.UserInput.slice(item.start, item.end);
    let ent = item.role?item.entity + "(" + item.role + ")":item.entity;
    utter.push( <Entity key={index+part} text={part} entity={ent} /> );
    idx = item.end;
  });
  utter.push(React.createElement("span", { className: "unrecognized", key: idx }, utteranceData.UserInput.slice(idx)));
  return utter;
}

const ClassifiedUtterance = props => {
    const { utteranceData, handleSelect, index, value, handleRadio, intent } = props;
    const date =  moment(utteranceData.Time).format("MMMM DD, YYYY @ hh:mm A");
    const utter = setUpUtter(utteranceData);
    return <Grid key={index} alignContent={"center"} alignItems={"center"} container spacing={2}>
            <Grid item xs={8}>
            <p className={props.classes.utteranceDate}><AccessTimeIcon fontSize="small" /> {date}</p>
              <p className={props.classes.utterance} onMouseUp={() => handleSelect(index)}> 
                {utter} 
              </p>
            </Grid>
            <Grid item style={{'textAlign':'center'}} xs={2}>
              <Tooltip placement="top" title="Click to edit intent">
                <div className={props.classes.intent} onClick={ e => props.openModal(index, "int")}>
                  <span className={props.classes.intentText}>
                    {typeof utteranceData.Intent === "string"?utteranceData.Intent:utteranceData.Intent.name + "[" + utteranceData.Intent.connection + "]"}
                  </span>
                </div> 
              </Tooltip>
            </Grid>
            <Grid item xs={2}>
              <div className={props.classes.actionsHolder}>
              <Tooltip placement="top" title="Mark Untrainable">
                    <ToggleButton 
                      style={{marginRight:5}}
                      className={props.classes.formGroupButtonRed}
                      size="small"
                      selected={value === "0"}
                      onChange={(e, val) => handleRadio(val, index)} 
                      value={value === "0"?null:"0"}
                      aria-label="yes">
                       <RemoveCircleIcon />
                    </ToggleButton> 
                  </Tooltip>
                  <Tooltip placement="top" title="Mark Correct">
                    <ToggleButton 
                      className={props.classes.formGroupButtonGreen}
                      size="small"
                      selected={value === "1"}
                      onChange={(e, val) => handleRadio(val, index)} 
                      value={value === "1"?null:"1"}
                      aria-label="yes">
                       <CheckIcon />
                    </ToggleButton> 
                  </Tooltip>
              </div>
             </Grid>
            </Grid>
  }


export default withStyles(styles)(React.memo(ClassifiedUtterance, uttersEqual));

function uttersEqual(prevProps, nextProps) {
  if (
    prevProps.utteranceData.entities !== nextProps.utteranceData.entities ||
    prevProps.utteranceData.Intent !== nextProps.utteranceData.Intent ||
    prevProps.value !== nextProps.value
  ) {
    return false;
  } else {
    return true;
  }
}
